import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=ba0e9c1c&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=ba0e9c1c&prod&lang=scss&scoped=true&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=ba0e9c1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0e9c1c",
  null
  
)

export default component.exports